import CTA from "./CTA/CTA"
import Expertise from "./Expertise/Expertise"
import Why from "./Why/Why"

const Home = () => {
  return (
    <>
      <CTA/>
      <Expertise/>
      <Why/>
    </>
  )
}

export default Home
